/**
 * CIDR range that represents all traffic.
 */
export const ALL_TRAFFIC = '0.0.0.0/0'
